<template>
  <div style="margin-top: 10px">
    <h2 class="text-center">{{Title}}</h2>

    <div class="row">
      <div class="col-md-12">
        <label>Género</label>
        <KitsCombo
          propertyName="Text"
          v-model="selectedGenero"
          :items="generos"
          propertyID="ID"
          nullText=" -- Seleccione un genero -- "
          @change="change"
        ></KitsCombo>

        <label>Nro Documento</label>
        <base-input v-model="Dni" @blur="change"></base-input>
        <label>Trámite</label>
        <base-input v-model="Tramite" @blur="change"></base-input>
      </div>
    </div>
  </div>
</template>

<script>
import KitsCombo from "@/components/KitsCombo";
import notificationHelpers from "@/helpers/notificationHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: { KitsCombo },

  props: {
    Title: {
      type: String,
      default: "",
      description: "",
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: "",
    },
  },
  data() {
    return {
      Dni: "",
      Tramite: "",
      Gender: "",
      generos: [
        { ID: 0, Text: "Masculino" },
        { ID: 1, Text: "Femenino" },
      ],
      selectedGenero: null,
      Errors: [],
      validateRequest: {},
    };
  },
  methods: {
    emitErrors(contexto) {
      this.$emit("setErrors", contexto.Errors);
    },
    change(element) {
      
      this.validate();

      if (this.Errors.length == 0) {
        this.JSONValue = JSON.stringify({
          OrderNumber: this.Tramite,
          Gender: this.generos[this.selectedGenero].Text,
          Number: this.Dni,
        });
      }
    },
    validate() {
      this.Errors = [];
      let _context=this;

      if (this.Dni.length == 0) {
        this.Errors.push("Debe completar el dni");
        this.emitErrors(this);
        return false;
      }

      if (this.Tramite.length == 0) {
        this.Errors.push("Debe completar el nro de tramite");
        this.emitErrors(this);
        return false;
      }

      if (this.selectedGenero == null) {
        this.Errors.push("Debe seleccionar el genero");
        this.emitErrors(this);
        return false;
      }

      var isMale = false;

      if (this.selectedGenero == 0) {
        isMale = true;
      }

      var Request = {
        Number: this.Dni,
        OrderNumber: this.Tramite,
        IsMale: isMale,
      };

      if (
        Request.Number != this.validateRequest.Number ||
        Request.OrderNumber != this.validateRequest.OrderNumber ||
        Request.IsMale != this.validateRequest.IsMale
      ) {
        this.validateRequest = Request;

        axiosHelpers.axiosPost(
          "Account/ValidatePerson",
          Request,
          _context,

          function (data) {
            var result = false;
            if (
              data != undefined &&
              data != null &&
              data.ResponseVM != undefined &&
              data.ResponseVM != null
            )
              result = data.ResponseVM.Result;

            if (!result) {
              _context.Errors.push("No hemos podido validar tu identidad");
              _context.emitErrors(_context);
              return;
            }

            if (data.ResponseVM.Result) {
              _context.Errors=[];
              _context.emitErrors(_context);
              _context.$emit("saveValue", {
                MissingItemEntityID: _context.MissingItemEntityID,
                JSON: _context.JSONValue,
              });
            }
          }
        );
      }
    },
  },
};
</script>